import * as React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import { brandGradient } from '../shared-theme/themePrimitives';

const items = [
  {
    icon: <GroupsRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Vetted creators',
    description:
      'Browse a curated roster of influencers across Instagram, TikTok and YouTube, ranked by real performance.',
  },
  {
    icon: <CampaignRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Book campaigns fast',
    description:
      'Reach out, agree on rates and lock in reels, stories or live collabs, all in one place.',
  },
  {
    icon: <InsightsRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'AI-matched picks',
    description:
      'Our AI search surfaces the right creators for your brand and budget in seconds, not weeks.',
  },
  {
    icon: <BoltRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Fast, transparent pricing',
    description:
      'See rates up front and work only with creators who respond quickly.',
  },
];

export default function Content() {
  return (
    <Stack
      sx={{ flexDirection: 'column', alignSelf: 'center', gap: 4, maxWidth: 450 }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          background: brandGradient,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          display: 'inline-block',
        }}
      >
        The Creator Match
      </Typography>

      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
}
